import * as React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker';
import { TextField } from '@mui/material';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { useFormik } from 'formik';
import { getUser, listCompanies, listLicenseTypes } from '../../services/service';

const defaultResponse = {
  count: 0, results: [], next: null, previous: null
}


export default function LicenseModelsFilter(props) {
  const {
    pageSize,
    loading,
    setLicensesData,
    setLoading,
    setFilters
  } = props;
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [companyData, setCompanyData] = React.useState(defaultResponse);
  const [initialDatetime, setInitialDatetime] = React.useState(null);
  const [finalDatetime, setFinalDatetime] = React.useState(null);


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const getCompanyFn = React.useCallback(() => {
    setLoading(true);
    listCompanies(1, 1000)
      .then((response) => {
        setCompanyData(response.data)
      })
      .catch((error) => {
        getUser({ expand: "company" }).then((res) => {
          setCompanyData({ results: [res.data["company"]] })
        }).catch((error) => {
          console.log(error)
        }).finally(setLoading(false))
      })
      .finally(setLoading(false))
  }, [])

  React.useEffect(() => {
    getCompanyFn()
  }, [])


  const formik = useFormik({
    initialValues: {
      created_at__gte: null,
      created_at__lte: null
    },
    // validationSchema: validationSchema,
    onSubmit: (values) => {
      var filters = {
        created_at__gte: initialDatetime.toISOString(),
        created_at__lte: finalDatetime.toISOString(),
      }
      setFilters(filters)
      listLicenseTypes(
        1,
        pageSize,
        filters
      ).then((response) => {
        if (response.status === 200) {
          setLicensesData(response.data)
          handleClose()
        } else {
          console.log(response.data)
        }
      }).finally((resp) => {
        setLoading(false)
      })

    },
  })

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
        Filtrar
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle id="responsive-dialog-title">
            {"Selecione os filtros desejados"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ width: "18rem" }}>
              <div style={{ margin: "1rem" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <div style={{ margin: "1rem 0rem", width: "18rem" }}>
                    <MobileDateTimePicker
                      label="Data inicial"
                      ampm={false}
                      inputFormat="dd/MM/yy HH:mm"
                      name="created_at__gte"
                      emptyLabel="custom label"
                      value={initialDatetime}
                      onChange={(value) => {
                        setInitialDatetime(value);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </div>
                  <div style={{ textAlign: "center" }}>até</div>
                  <div style={{ margin: "1rem 0rem" }}>
                    <MobileDateTimePicker
                      label="Data final"
                      ampm={false}
                      inputFormat="dd/MM/yy HH:mm"
                      name="created_at__lte"
                      value={finalDatetime}
                      onChange={(value) => {
                        setFinalDatetime(value);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </div>
                </LocalizationProvider>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit">
              Filtrar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}